import React, { useState } from "react";
import FireflyEffect from "../../components/FireflyEffect/FireflyEffect";
import Captcha from "../../components/Captcha";
import "./ContactPage.css";
import { Helmet } from "react-helmet-async";

const ContactPage = () => {
  const CONTACT_ENDPOINT =
    "https://grauconejo13-portfolio-backend.netlify.app/.netlify/functions/sendContactEmail";

  const baseUrl = window.location.hostname.includes("vanessainthefifthdimension.com")
    ? "https://vanessainthefifthdimension.com"
    : "https://vanessainthefifthdimension.netlify.app";

  const [captchaToken, setCaptchaToken] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false); // ✅ THIS is the key

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setErrorMessage("⚠️ Please verify that you are not a robot.");
      return;
    }

    setIsSending(true);
    setErrorMessage("");

    const form = e.target;

    try {
      const res = await fetch(CONTACT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.value,
          email: form.email.value,
          message: form.message.value,
          token: captchaToken,
        }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.message || "Failed to send message");
      }

      // ✅ THIS ALWAYS RENDERS
      setIsSuccess(true);
      form.reset();
      setCaptchaToken(null);

    } catch (err) {
      console.error("Contact error:", err);
      setErrorMessage(err.message || "Something went wrong.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="contact-wrapper">
      <FireflyEffect />

      <Helmet>
        <title>Contact | Vanessa Victorino</title>
        <meta
          name="description"
          content="Get in touch with Vanessa Victorino — collaborations, questions, and thoughtful conversations welcome."
        />
        <meta property="og:url" content={`${baseUrl}/contact`} />
      </Helmet>

      <div className="contact-container">
        <h1>Contact Me</h1>

        {/* ✅ SUCCESS STATE */}
        {isSuccess ? (
          <div className="contact-success">
            <h2>Thank you ✨</h2>
            <p>Your message has been sent successfully.</p>
            <p>I’ll get back to you as soon as I can.</p>
          </div>
        ) : (
          <>
            {errorMessage && (
              <div className="captcha-error-message">{errorMessage}</div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Name</label>
                  <input name="name" required />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input name="email" type="email" required />
                </div>
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea name="message" rows="6" required />
              </div>

              <div className="form-group">
                <Captcha onVerify={setCaptchaToken} />
                <button className="btn" disabled={isSending}>
                  {isSending ? "Sending…" : "Send Message"}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
